import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import apiClient from '../api/api'; // Corrected import path
import { API_ENDPOINTS } from '../endpoints';
import { clearPersistedKeys } from '../utils/storage';

const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      subscriptions: [],
      institution: null,
      refreshToken: null,
      credentials: null,
      privileges: [],
      
      login: async (credentials) => {
        const response = await apiClient.post(API_ENDPOINTS.login, credentials);
        const { data } = response;
        const user = data?.data?.contextVO?.user || null;
        const institution = data?.data?.contextVO?.user?.rank?.institution || null;
        const token = data?.token || null;
        const refreshToken = data?.refreshToken || null;
        set({
          user,
          institution,
          token,
          refreshToken,
          subscriptions: [],
          credentials,
        });

        let privileges = [];
        try {
          const privResponse = await apiClient.get(API_ENDPOINTS.getAssignedPrivileges(institution?.id), {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          privileges = privResponse.data || [];
          set({ privileges });
        } catch (error) {
          console.error('Failed to fetch user privileges:', error);
          set({ privileges: [] });
        }

        let subscriptions = [];
        try {
          const subResponse = await apiClient.get(API_ENDPOINTS.getLearningPathways, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          subscriptions = subResponse.data || [];
          set({ subscriptions });
        } catch (error) {
          console.error('Failed to fetch learning pathways:', error);
          set({ subscriptions: [] });
        }

        return { user, institution, token, refreshToken, subscriptions, privileges, raw: response.data };
      },
      logout: () => {
        set({ user: null, institution: null, token: null, refreshToken: null, subscriptions: [], credentials: null, privileges: [] });
        try {
          localStorage.removeItem('auth-storage');
          const keysToClear = [
            'create-test-details',
            'create-test-pathway',
            'create-test-assignment',
            'question-selection',
          ];
          clearPersistedKeys(keysToClear);
        } catch {
          /* ignore */
        }
      },
      setToken: (token) => set({ token }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useAuthStore;
